import type { SearchResponse } from './types';

/**
 * API base URL.
 *   - In dev: '/api', proxied to wrangler dev by Vite (vite.config.ts).
 *   - In prod: configured via `VITE_API_BASE_URL` env at build time, e.g.
 *     `VITE_API_BASE_URL=https://api.resonance.fm pnpm build`.
 *   - Fallback: same-origin '/api' (works if Pages and the API share a hostname).
 */
export const API_BASE: string = import.meta.env.VITE_API_BASE_URL ?? '/api';

export async function search(query: string, signal?: AbortSignal): Promise<SearchResponse> {
  const r = await fetch(`${API_BASE}/search`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ query }),
    signal,
  });
  if (!r.ok) {
    const text = await r.text().catch(() => '');
    throw new Error(`Search failed: ${r.status} ${text}`);
  }
  return r.json();
}

export function audioUrl(episodeId: string): string {
  return `${API_BASE}/audio/${encodeURIComponent(episodeId)}`;
}
